import { endPoint } from './base.config';

export const bank = {
  index: `${endPoint}banks`,
  adminAutoImport: `${endPoint}banks/admin-auto-import`,
  getBankBySwiftCode: `${endPoint}banks/bank/bySwiftCode`,
  addAutoImport: `${endPoint}banks/addAutoImport`,
  updateAutoImport: `${endPoint}banks/updateAutoImport`,
  updateStatus: `${endPoint}banks/updateStatus`,
  getByCompany: `${endPoint}banks/getByCompany`,
  getByFilter: `${endPoint}banks/getByFilter`,
  getByTemplate: `${endPoint}banks/getByTemplate`,
};
